export default function getLoginRedirectionLink() {
  if (typeof window === 'undefined') {
    return '/login?context=courseAccess';
  }

  const targetPath = `${window.location.pathname}${window.location.search}${window.location.hash}`;

  const queryParams = new URLSearchParams({
    context: 'courseAccess',
    _target_path: targetPath,
  });

  return `/login?${queryParams.toString()}`;
}
